import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '@/features/auth/useAuth'

const baseFormatOptions: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: '2-digit',
  second: undefined,
  hour12: true,
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
}

export const useFormattedDateTime = (timezoneParam: string) => {
  const { user } = useAuth()
  const { i18n } = useTranslation()

  const [time, setTime] = useState(new Date())

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date())
    }, 60_000)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  const formatDateTime = (date: Date) => {
    const timezone = timezoneParam || user?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone

    const formatOptions = {
      ...baseFormatOptions,
      timeZone: timezone,
    }

    if (i18n.language === 'ar-AR') {
      formatOptions.numberingSystem = 'arab'
    }

    const formatter = new Intl.DateTimeFormat(i18n.language, formatOptions)

    return formatter.format(date)
  }

  return formatDateTime(time)
}
